<template>
	<v-container
		fluid
		fill-height
		height="100%"
		class="d-flex flex-column justify-center align-center text-center"
	>
		<v-img
			src="@/assets/images/dactyl_access_denied.png"
			lazy-src="@/assets/images/dactyl_access_denied.png"
			transition="fade-transition"
			height="500px"
			width="500px"
			contained
			max-height="500px"
			max-width="500px"
			class="d-block mx-auto"
		/>
		<p class="mt-4 text-h6">You do not have permission to view this page.</p>
		<p class="mt-4 text-h6">
			<a
				class="text-secondary-ink cursor-pointer font-weight-bold text-decoration-underline"
				@click="goToDashboard"
			>
				Return to home page
			</a>
		</p>
	</v-container>
</template>

<script>
export default {
	name: "DactylAccessDenied",

	methods: {
		goToDashboard() {
			this.$router.push("/home");
		},
	},
};
</script>
